import { StartFlowType } from "components/CC/types/enums";
import { createContext, ReactNode, useContext, useMemo } from "react";

interface CCStartNodesContextValue {
    /** Flow types of existing start nodes */
    existingFlowTypes: StartFlowType[];
    /** Total number of start nodes */
    totalStarts: number;
}

const CCStartNodesContext = createContext<CCStartNodesContextValue>({
    existingFlowTypes: [],
    totalStarts: 0,
});

interface CCStartNodesProviderProps {
    existingFlowTypes: StartFlowType[];
    totalStarts: number;
    children: ReactNode;
}

export const CCStartNodesProvider = ({ existingFlowTypes, totalStarts, children }: CCStartNodesProviderProps) => {
    const value = useMemo(
        () => ({
            existingFlowTypes,
            totalStarts,
        }),
        [existingFlowTypes, totalStarts]
    );

    return <CCStartNodesContext.Provider value={value}>{children}</CCStartNodesContext.Provider>;
};

export const useCCStartNodes = () => {
    return useContext(CCStartNodesContext);
};
